module.exports = __webpack_public_path__ + "static/media/ban.feeac21e.svg";